export default function togglePassword() {
    const togglePasswordButtons = document.querySelectorAll(".toggle-password");
    
    togglePasswordButtons.forEach(button => {
        button.addEventListener("click", () => {
            const passwordField = button.previousElementSibling;
            const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
            passwordField.setAttribute("type", type);
            button.querySelector("i").classList.toggle("fa-eye");
            button.querySelector("i").classList.toggle("fa-eye-slash");
        });
    });
}